module.exports = __webpack_public_path__ + "static/media/doctor-report.90c0edf5.svg";